import { Ds } from "@accurx/design";

export const PageTitle = ({
    pageNumber,
    pageTitle,
}: {
    pageNumber: string;
    pageTitle: string;
}): JSX.Element => (
    <Ds.Flex gap="1" alignItems="center" flexDirection="column">
        <Ds.Text color={"zinc"} children={`Step ${pageNumber} of 4`} />
        <Ds.Text as="h1" weight="bold" size="large">
            {pageTitle}
        </Ds.Text>
    </Ds.Flex>
);
